import React, { useEffect } from "react";
import {
  Page,
  SubmitButton,
  required,
  FormGroup,
  DatePicker,
} from "components/common";
import { Control, actions } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";
import {Trans} from "react-i18next";
import Select from "react-select";
 

export const PublicHolidayEdit = ({ t, url = "public_holidays", model = "local", _payroll, match, updateList, id }) => {
  const { dispatch, setValue, Form, save, loaded, load, getTitle } = useForm({
    model,
  });

  async function onSubmit(item) {
    try {
      await save(_payroll, url, item);
      NotificationManager.success(t("Saved successfully"));
      updateList()

    } finally {
      dispatch(actions.setPending(model, false));
    }
  }
  useEffect(
    () =>
      void (async () => {
        const item = await load(_payroll, url, id, {});
        setValue(item);
      })(),
    [id]
  );

  const publicHolidayTypeOption = [
    {label: t("Monthly"), value: "Monthly"},
    {label: t("Yearly"), value: "Yearly"},
  ]
  
  if (!loaded) return null;

  
  return (
      <Form
        onSubmit={onSubmit}
        validators={{
          name: { required },
          date: { required },
        }}
      >
        <FormGroup label="Name *" model=".name">
          <Control.text model=".name" />
        </FormGroup>

        <FormGroup label="Date *" model=".date" className="mt-3 fix-date-picker-modal">
          {/* <Input type="date" model=".date" className="form-control"/> */}
          <DatePicker type="date" model=".date" className="form-control"/>

        </FormGroup>

        <FormGroup addControlClass={false} label="Repeat Holiday *" model=".public_holiday_type">
          <Control.text  style={{backgroundColor:'#F4F7FE'}}
            model=".public_holiday_type"
            component={Select}
            options={publicHolidayTypeOption}
            simpleValue
          />
        </FormGroup>
        <div className="d-flex justify-content-end mt-3">
          <SubmitButton>
            {id==="new" ?
            <Trans>Add</Trans>
            :
            <Trans>Save</Trans>
            }
          </SubmitButton>
        </div>
      </Form>
  );
};

export default PublicHolidayEdit;
